import React, { useState, useEffect } from 'react';
import { Label } from "../atoms/label"
import useMedia from 'use-media';
import { useStore } from "react-redux";
import { Button } from '../atoms/button';
import reserveImage from '../../resources/image/reserved.png';
export const SoloTimeSet = (props) => {

    const {
        courseList,
        onClickReserve,
    } = props;

    return (
        <div className='soloStartTime_table'>
            <div className='soloStartTime_tableHeader'>
                <div className='soloStartTime_tableHeaderCell'>
                    <Label label='コース' />
                    <Label label='時間' />
                </div>
                <div className='soloStartTime_tableHeaderCell soloStartTime_tableHeaderCell2'>
                    <Label label='予約状況' />
                </div>
            </div>
            {courseList?.map((course, index) =>
                <div className='soloStartTime_tableRow'>
                    <div className='soloStartTime_tableCellLeft'>
                        <Label label={course.courseName} className='soloStartTime_time' />
                        <Label label={course.teetime} className='soloStartTime_time' />
                        <Button buttonText='予約する' onClick={() => onClickReserve(course)} className='soloStartTime_reserveBtn' />
                    </div>
                    <div className='soloStartTime_tableCellGroupArea'>
                        <div className='soloStartTime_tableCellGroup' >
                            {(() => {
                                const items = [];
                                for (let i = 0; i < 4; i++) {
                                    course.playerList?.[i] ?
                                        Object.keys(course.playerList[i]).length ?
                                            items.push(
                                                <div className='soloStartTime_tableCellRight soloStartTime_tableCellRightInfo'>
                                                    <div>
                                                    <Label
                                                        label={course.playerList[i].genderType + " " + course.playerList[i].ageGeneration}
                                                    />
                                                    <Label
                                                        label={"HCP：" + course.playerList[i]?.handicap}
                                                    />
                                                    </div>
                                                </div>
                                            )
                                            :
                                            items.push(
                                                <div className='soloStartTime_tableCellRight soloStartTime_tableCellRightInfo'>
                                                    <Label
                                                        className='soloStartTime_tableCellRightInfo'
                                                        label="情報なし"
                                                    />
                                                </div>
                                            )
                                        :
                                        items.push(
                                            <div className='soloStartTime_tableCellRight soloStartTime_tableCellRightInfo'>
                                                <div className='soloStartTime_open'>
                                                    <img src={reserveImage} className='soloStartTime_img'/>
                                                </div>
                                            </div>
                                        )
                                }
                                return items
                            })()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
